import React from 'react';
import { StyledRequiredIndicator } from './styles';
export const RequiredIndicator = (props) => {
    return React.createElement(StyledRequiredIndicator, { fulfilled: props.fulfilled });
};
//# sourceMappingURL=RequiredIndicator.js.map